import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { PhoneNumbersFilterOption } from '../../models/phone-number-filter-option';
import { PhoneNumberRegister } from '../../phone-number-register';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-location-phone-number-register',
    templateUrl: './location-phone-number-register.component.html',
    standalone: false
})
export class LocationPhoneNumberRegisterComponent extends PhoneNumberRegister {
   @Input() set locationId(value: number) {
      this._locationId = value;
      this.filters = this.buildFilters();
   }

   get locationId(): number {
      return this._locationId;
   }

   private _locationId: number;

   filters: PhoneNumbersFilterOption[] = [];

   constructor(public store: Store) {
      super(store);
      store.select(getSelectedAccountId).pipe(
         filter((accountId: number | null): accountId is number => {
            return accountId != null;
         }),
         map((accountId: number) => {
            const accountFilter: PhoneNumbersFilterOption[] = [
               {
                  field: 'AccountId',
                  operation: FilterOperations.EqualTo,
                  type: 'numeric',
                  value: accountId,
               },
            ];
            this.filters.push(...accountFilter);
            return this.filters;
         })
      );
      this.columns = ['phoneNumber', 'openExtension', 'closedExtension'];
   }

   private buildFilters(): PhoneNumbersFilterOption[] {
      if (this.locationId != null) {
         const locationFilter: PhoneNumbersFilterOption = {
            field: 'LocationId',
            operation: FilterOperations.EqualTo,
            type: 'numeric',
            value: this.locationId,
         };
         this.filters.push(locationFilter);
      }
      return this.filters;
   }
}
